import React, {Component} from "react";
import {Alert, Button, Col, FormControl, OverlayTrigger, Popover, Row, Spinner} from "react-bootstrap";
import shareImg from "../../images/share-solid.svg";
import Axios from "axios";
import './EditBoards.scss';
import loadingSvg from "../../images/loading.svg";
import {ReactComponent as EyeSolid} from  "../../images/eye-solid.svg";
import {ReactComponent as EyeSlashSolid} from "../../images/eye-slash-solid.svg";
import {ReactComponent as TrashIcon} from "../../images/trash-alt-regular.svg";

import {boardMatchesSearch, CalcOverride, GetSelectedBoards, GetSortedVendorIds, IsUserOwner} from "../../helpers/Helpers";
import {Link} from "react-router-dom";
import {withRouter} from "../../helpers/withRouter";
import {ReactComponent as EditSvg} from "../../images/edit-regular.svg";
import {GetUser} from "../../helpers/User";
import EditImageModal from "../EditBoard/EditImageModal";
import UploadImagesModal from "../EditCampaign/UploadImagesModal";
import moment from "moment";

class EditBoardsBase extends Component {
    state = {
        campaign:{},
        lastSavedCampaign:{},
        fields: [],
        search: "",
        allSelected:true,
        sortedVendorIds:[],
    }
    constructor(props) {
        super(props);
        // This binding is necessary to make `this` work in the callback
        this.reset = this.reset.bind(this);
        this.exportAuthorizationXlsx = this.exportAuthorizationXlsx.bind(this);
        this.exportProposalXLSX = this.exportProposalXLSX.bind(this);
        this.exportPhotosheets = this.exportPhotosheets.bind(this);
        this.exportOverrideXLSX = this.exportOverrideXLSX.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
    }
    componentDidMount() {
        this.getCampaignAPI()
        let params = new URLSearchParams(window.location.search);
        this.setState({search:params.get("search")})
        GetUser().then((user=>{
            this.setState({user:user})
        }))
    }

    specialFields = ["status","unit #","vendor","media format","description","image url","h x w","digital (y/n)","facing","market", "lat","lon",
        "4-wk imp","cpm","start date","end date","rate card","neg rate","remnant rate","production","install","notes"]

    getCampaignAPI(){
        let campaignId = this.props.match.params.campaignId;
        // let campaignId = this.props.match.params.campaignId;
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/campaign/"+campaignId).then((response) => {
            if(response.data.message === "still looking"){
                setTimeout(()=>{
                    this.getCampaignAPI();
                },3000);
            }else{
                //loop through all boards to get unique fields
                let campaign = response.data.campaign;
                let sortedVendorIds = GetSortedVendorIds(campaign);
                let fields = new Set();
                //hardcode special fields, cpm, address,
                for(let f of this.specialFields){
                    fields.add(f);
                }
                for(let boardId in campaign.boards){
                    campaign.boards[boardId].selected = true;
                    for(let field in campaign.boards[boardId].fields){
                        fields.add(field);
                    }
                }
                //json to clone; pointer issue
                this.setState({sortedVendorIds:sortedVendorIds,lastSavedCampaign: JSON.parse(JSON.stringify(campaign)), campaign: campaign, fields: Array.from(fields)});
            }
        }).catch(error => {
            if(error && error.response && error.response.data){
                this.setState({error:{title:"Error Finding Campaign!", body:error.response.data.message}});
            }
        });
    }
    getField(field,board){
        if(board[field]){
            return board[field];
        }else if(board.fields[field]){
            return board.fields[field];
        }
        return ""
    }
    setField(field,value,board){
        if(value === "false"){
            value = false
        }else if(value === "true"){
            value = true
        }
        if(board[field] !== undefined){
            board[field] = value;
            if(["cpm","lat","lon"].includes(field)){
                board[field] =  parseFloat(value);
                board.fields[field] = parseFloat(value);
            }else if(["favorite"].includes(field)){
                if(typeof value == "boolean"){
                    board.fields[field] = value;
                }else{
                    board.fields[field] = (value === "true");
                }
            }
        }else{
            board.fields[field] = value;
        }
        if(field === "image url"){
            board.images = [value];
        }
        return board;
    }
    reset(){
        let lsc = JSON.parse(JSON.stringify(this.state.lastSavedCampaign));
        console.log(lsc);
        this.setState({campaign:lsc});
    }
    saveChanges(){
        // console.log(this.state.campaign.boards["20012"].fields["facing"])
        let c = this.state.campaign;
        Axios.post(process.env.REACT_APP_BACKEND_URL+"/campaign/re-save-campaign",{
            campaign: c,
        }).then((response) => {
            let lsc = JSON.parse(JSON.stringify(this.state.campaign));
            this.setState({lastSavedCampaign:lsc})
        }).catch(error => {
            console.log(error);
            if(error && error.response){
                this.setState({error:{title:"Error Saving Campaign!",body:error.response.data.message}});
            }
        });
    }
    exportAuthorizationXlsx(){
        let ws_data = [];
        // let headers = [];
        // for(let f of this.state.fields){
        //     headers.push(f.toUpperCase());
        // }
        // ws_data.push(headers);
        if(!this.state.campaign || !this.state.campaign.boards){
            return
        }
        let boards = GetSelectedBoards(this.state.campaign.boards,this.state.search)

        for(let b of this.state.sortedVendorIds){
            let vendorId = b.vendorId;
            let board = boards[vendorId];
            if(!board){
                continue
            }
            let totalCost = this.calculateTotalCost(board.fields);
            let values = [
                board.fields["market"],
                board.fields["unit #"],
                board.fields["media format"],
                board.fields["# units"],
                board.fields["description"],
                board.fields["start date"] && moment(board.fields["start date"]).isValid()
                    ? moment(board.fields["start date"]).format("MM/DD/YY")
                    : board.fields["start date"],
                board.fields["end date"] && moment(board.fields["end date"]).isValid()
                    ? moment(board.fields["end date"]).format("MM/DD/YY")
                    : board.fields["end date"],
                board.fields["4-wk periods"],
                board.fields["h x w"],
                board.fields["neg rate"],
                board.fields["production"],
                board.fields["install"],
                totalCost,
                board.fields["notes"],
            ];
            ws_data.push(values);
        }
        console.log(ws_data);

        this.postDataForExport('/campaign/export-xlsx', {
            ws_data,
            campaign_id: this.state.campaign._id,
            type: 'client',
        });
        this.reSaveIfOwner();
    }

    calculateTotalCost(boardFields) {
        let totalCost = 0;

        if (boardFields["neg rate"] && !isNaN(boardFields["neg rate"])){
            totalCost = boardFields["neg rate"];
        } else if (boardFields["4-wk media cost"] && !isNaN(boardFields["4-wk media cost"])){
            totalCost = boardFields["4-wk media cost"];
        }
        if (boardFields["4-wk periods"] && !isNaN(boardFields["4-wk periods"])){
            totalCost *= boardFields["4-wk periods"];
        }
        if (boardFields["prod rate"] && !isNaN(boardFields["prod rate"])){
            totalCost += boardFields["prod rate"];
        }
        if (boardFields["install"] && !isNaN(boardFields["install"])){
            totalCost += boardFields["install"];
        }

        return totalCost;
    }

    exportProposalXLSX() {
        let ws_data = [];
        if(!this.state.campaign || !this.state.campaign.boards){
            return
        }
        let boards = GetSelectedBoards(this.state.campaign.boards,this.state.search)
        let additionalFields = [];
        for(let field of this.state.fields){
            if(!this.specialFields.includes(field)){
                additionalFields.push(field);
            }
        }
        for(let b of this.state.sortedVendorIds){
            let vendorId = b.vendorId;
            let board = boards[vendorId];
            if(!board){
                continue
            }
            let values = [
                board.fields["unit #"],
                board.fields["vendor"],
                board.fields["media format"],
                board.fields["market"],
                board.fields["description"],
                board.fields["image url"],
                board.fields["h x w"],
                board.fields["digital"] || board.fields["digital (y/n)"],
                board.fields["facing"],
                board["lat"],
                board["lon"],
                board.fields["4-wk imp"],
                board.fields["cpm"],
                board.fields["start date"] && moment(board.fields["start date"]).isValid()
                    ? moment(board.fields["start date"]).format("MM/DD/YY")
                    : board.fields["start date"],
                board.fields["end date"] && moment(board.fields["end date"]).isValid()
                    ? moment(board.fields["end date"]).format("MM/DD/YY")
                    : board.fields["end date"],
                board.fields["rate card"],
                board.fields["neg rate"],
                board.fields["remnant rate"],
                board.fields["production"],
                board.fields["install"],
                board.fields["notes"],
            ];
            for(let field of additionalFields){
                values.push(this.getField(field,board));
            }
            ws_data.push(values);
        }

        this.postDataForExport('/campaign/export-xlsx', {
            ws_data,
            campaign_id: this.state.campaign._id,
            type: 'proposal',
            additional_fields: additionalFields,
        });
        this.reSaveIfOwner();
    }

    exportPhotosheets() {
        let ws_data = [];
        if (!this.state.campaign || !this.state.campaign.boards) {
            return;
        }
        let boards = GetSelectedBoards(this.state.campaign.boards, this.state.search);

        for (let b of this.state.sortedVendorIds) {
            let vendorId = b.vendorId;
            let board = boards[vendorId];
            if (!board) {
                continue
            }
            const values = [
                "unit #",
                "market",
                "media format",
                "description",
                "image url",
                "h x w",
                "digital",
                "facing",
                "lat",
                "lon",
                "4-wk imp",
            ].reduce((acc, key) => {
                acc[key] = board.fields[key];
                return acc;
            }, {});
            ws_data.push(values);
        }

        this.postDataForExport('/campaign/export-pptx', {ws_data}, '.pptx');
        this.reSaveIfOwner();
    }

    exportOverrideXLSX() {
        let ws_data = [];
        if (!this.state.campaign || !this.state.campaign.boards) {
            return;
        }
        let boards = GetSelectedBoards(this.state.campaign.boards, this.state.search);

        for (let b of this.state.sortedVendorIds) {
          let vendorId = b.vendorId;
          let board = boards[vendorId];
          if (!board) {
            continue;
          }
          const values = [
            "unit #",
            "market",
            "media format",
            "description",
            "install date",
            "start date",
            "end date",
            "takedown date",
            "neg rate",
            "4-wk imp",
          ].reduce((acc, key) => {
            switch (key) {
              case "install date":
              case "start date":
              case "end date":
              case "takedown date":
                acc[key] =
                  board.fields[key] && moment(board.fields[key]).isValid()
                    ? moment(board.fields[key]).format("MM/DD/YY")
                    : board.fields[key];
                return acc;
              default:
                acc[key] = board.fields[key];
                return acc;
            }
          }, {});

          let override = CalcOverride(board);
          values["bonus imp"] = override?.bonusImpressions;
          values["override percent"] = override?.overridePercent;
          values["override value"] = override?.overrideMediaValue;
          values["bonus days"] = board.fields["takedown date"]
              ? override?.extraDays
              : undefined;

          ws_data.push(values);
        }

        this.postDataForExport('/campaign/override-export', {
            ws_data,
            campaign_id: this.state.campaign._id,
        });
        this.reSaveIfOwner();
    }

    postDataForExport(endpoint, data, format = '.xlsx') {
        this.setState({exportLoading: true});
        Axios({
            method: 'post',
            url: process.env.REACT_APP_BACKEND_URL + endpoint,
            data,
            responseType: 'blob', // important
        }).then((response) => {
            this.downloadResponseDocument(response.data, format);
        }).finally(() => {
            this.setState({exportLoading: false});
        });
    }

    downloadResponseDocument(responseData, format) {
        const url = window.URL.createObjectURL(new Blob([responseData]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.state.campaign.name}-export${format}`); // or any other extension
        document.body.appendChild(link);
        link.click();
    }

    reSaveIfOwner() {
        let user = this.state.user;
        let isOwner = IsUserOwner(user, this.state.campaign);
        if (isOwner) {
            this.saveChanges();
        }
    }
    //["vendorId","locationDescription","lat","lon","favorite"]
    // $ npm install tableexport
    render() {
        let user = this.state.user;
        let isOwner = IsUserOwner(user, this.state.campaign);

        return <div className={"p-5"}>
            <div className={"d-flex justify-content-between flex-wrap align-items-center"}>
                <h1>{this.state.campaign.name}</h1>
                <div style={{flexBasis:"30%"}}>
                    {/*<Link to="/campaigns/create" className={"btn btn-primary btn-lg"}>*/}
                    {/*    + New*/}
                    {/*</Link>*/}
                    <FormControl
                        placeholder="Filter..."
                        aria-label="Filter..."
                        aria-describedby="basic-addon2"
                        value={this.state.search}
                        onChange={e => this.setState({ search: e.target.value })}
                    />
                </div>
            </div>
            <div className={"d-flex justify-content-between mt-4"}>
                <div>
                    <OverlayTrigger trigger="click" placement="bottom" 
                        overlay={ExportPopover(this.exportAuthorizationXlsx,this.exportProposalXLSX,this.exportPhotosheets,this.exportOverrideXLSX,this.state.campaign,this.state.exportLoading)}>
                        <Button>
                            <img height={12} style={{marginRight: 8, marginBottom: 4}} src={shareImg} alt={"Share icon"}/>
                            Export
                        </Button>
                    </OverlayTrigger>
                    <Button className={"ms-4"} onClick={()=>{
                        this.setState({showUploadImgModal:true})
                    }}>+ Upload Images </Button>
                    <Button className={"ms-4"} onClick={()=>{
                        window.open("/campaign/"+this.state.campaign._id +"/upload", '_blank').focus();
                    }}>+ Upload Media</Button>
                </div>
                {isOwner ?
                    <div>
                        <span className={"boring-btn me-4"} onClick={this.reset}>Reset</span>
                        <Button onClick={this.saveChanges}>Save Changes</Button>
                    </div>:""}
            </div>
            <div className={"mw-100 py-4 overflow-auto"}>
                <table className={"edit-table"}>
                    <thead>
                    <tr>
                        <th className={"text-right"}>
                            <input type={"checkbox"} checked={this.state.allSelected} onChange={()=>{
                                let c = this.state.campaign;
                                for(let key in c.boards){
                                    c.boards[key].selected = !this.state.allSelected;
                                }
                                this.setState({campaign: c,allSelected: !this.state.allSelected});
                            }}/>
                        </th>
                        {this.state.fields.map((field,i) => {
                            if(!isOwner && this.state.campaign.hiddenFields.includes(field)){
                                return <></>
                            }
                            return <th className={"p-0 options-th"}>
                                {[16,17,18,22].includes(i) ? "":<div style={{height:24}}/> }
                                {i < 22 && isOwner? <div style={{height:24}}/>://there are 22 hardcoded/required fields
                                    <div>
                                        {isOwner?
                                            <>
                                                {this.state.campaign.hiddenFields.includes(field) ?
                                                    <EyeSlashSolid onClick={()=>{
                                                        let c = this.state.campaign
                                                        if(!c.hiddenFields){
                                                            c.hiddenFields = [];
                                                        }
                                                        if( c.hiddenFields.includes(field)){
                                                            c.hiddenFields = c.hiddenFields.filter(item => item !== field)
                                                        }else{
                                                            c.hiddenFields.push(field);
                                                        }
                                                        this.setState({campaign:c});
                                                    }}
                                                    />
                                                    :
                                                    <EyeSolid onClick={()=>{
                                                        let c = this.state.campaign
                                                        if(!c.hiddenFields){
                                                            c.hiddenFields = [];
                                                        }
                                                        if( c.hiddenFields.includes(field)){
                                                            c.hiddenFields = c.hiddenFields.filter(item => item !== field)
                                                        }else{
                                                            c.hiddenFields.push(field);
                                                        }
                                                        this.setState({campaign:c});
                                                    }}
                                                    />
                                                }
                                                <TrashIcon onClick={()=>{
                                                    let c = this.state.campaign;
                                                    for(let key in c.boards){
                                                        delete c.boards[key].fields[field];
                                                    }
                                                    let fields =  this.state.fields;
                                                    fields = fields.filter(item => item !== field);
                                                    // console.log(fields);
                                                    this.setState({campaign:c,fields:fields});
                                                }}/>
                                            </>:""}
                                    </div>}
                                {i === 22 ? <div className={"headers-title"} style={{background:"#B4A7D6"}}>Additional Fields</div>:""}
                                {i === 16 ? <div className={"headers-title border-right-0"}/>:"" }
                                {i === 17 ? <div className={"headers-title border-left-0 border-right-0"}>Per 4-Wk</div>:"" }
                                {i === 18 ? <div className={"headers-title border-left-0"}/>:"" }
                                <input key={i} className={"text-center font-weight-bold "+ (field === "description" ? "large-col":"")+ (field === "notes" ? "med-col":"")} type={"text"} value={field} readOnly={!isOwner}/>
                            </th>
                        })}
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.campaign.boards ? this.state.sortedVendorIds.map((b) => {
                        let campaign =  this.state.campaign;
                        let boardId = b.vendorId;
                        let board =campaign.boards[boardId];
                        if(!boardMatchesSearch(board,this.state.search)){
                            return <></>
                        }
                        return <tr key={boardId}>
                            <td>
                                <div style={{whiteSpace:"nowrap"}} className={"board-options-container"}>
                                    {isOwner ?
                                        <Link target={"_blank"} className={"boring-btn me-4"} to={`/campaigns/${this.state.campaign._id}/edit-board?board=${escape(boardId)}`}><EditSvg/> Edit</Link>
                                        :""}
                                    <input type={"checkbox"} checked={board.selected} onChange={()=>{
                                        campaign.boards[boardId].selected = !board.selected;
                                        this.setState({campaign: campaign})
                                    }}/>
                                </div>
                            </td>
                            {this.state.fields.map((field,i) => {
                                if(!isOwner && this.state.campaign.hiddenFields.includes(field)){
                                    return <></>
                                }
                                return <td key={boardId + i} className={"p-0"}>
                                    <input className={"text-center " + (field === "description" ? "large-col":"")+ (field === "notes" ? "med-col":"")} type={"text"} readOnly={!isOwner} value={this.getField(field, board)}
                                        onChange={(event)=>{
                                            campaign.boards[boardId] = this.setField(field, event.target.value, board)
                                            this.setState({campaign: campaign})
                                        }}
                                    />
                                </td>
                            })}
                            </tr>
                    }) : <img alt={"loading-icon"} className={"m-auto d-block"} height={100} src={loadingSvg}/>}
                    </tbody>
                </table>
                {/*<div className={"d-none"}>*/}
                {/*    <table className={"full-table edit-table"} cellPadding={16} ref={(el)=>{this.fieldsTable=el}}>*/}
                {/*        <thead>*/}
                {/*        <tr>*/}
                {/*            {this.state.fields.map((field,i) => {*/}
                {/*                return <th className={"p-0"}>*/}
                {/*                    <p key={i+"-22"} className={"text-center font-weight-bold w-100"}>{field}</p>*/}
                {/*                </th>*/}
                {/*            })}*/}
                {/*        </tr>*/}
                {/*        </thead>*/}
                {/*        <tbody>*/}
                {/*        {this.state.lastSavedCampaign.boards ? Object.keys(this.state.lastSavedCampaign.boards).map((boardId) => {*/}
                {/*            let campaign =  this.state.lastSavedCampaign;*/}
                {/*            let board =campaign.boards[boardId];*/}
                {/*            return <tr key={boardId}>*/}
                {/*                {this.state.fields.map((field,i) => {*/}
                {/*                    return <td key={boardId + i+"-2"} className={"p-0"}>*/}
                {/*                        <p className={"text-center"}>{this.getField(field, board)}</p>*/}
                {/*                    </td>*/}
                {/*                })}*/}
                {/*            </tr>*/}
                {/*        }) : <img alt={"loading-icon"} className={"m-auto d-block"} height={100} src={loadingSvg}/>}*/}
                {/*        </tbody>*/}
                {/*    </table>*/}
                {/*</div>*/}
            </div>
            <div className={"d-flex justify-content-between mt-4"}>
                <OverlayTrigger trigger="click" placement="top" overlay={ExportPopover(this.exportAuthorizationXlsx,this.exportProposalXLSX,this.exportPhotosheets,this.exportOverrideXLSX,this.state.campaign,this.state.exportLoading)}>
                    <Button>
                        <img height={12} style={{marginRight: 8, marginBottom: 4}} src={shareImg} alt={"Share icon"}/>
                        Export
                    </Button>
                </OverlayTrigger>
                {isOwner ?
                    <div>
                        <span className={"boring-btn me-4"} onClick={this.reset}>Reset</span>
                        <Button onClick={this.saveChanges}>Save Changes</Button>
                    </div>
                :""}
            </div>
            {this.state.alert ? (
                <Alert style={{maxWidth:500, zIndex: 10000}} className={"mx-auto alert-top-right"}  variant="success" onClose={()=>{this.setState({alert: null})}} dismissible>
                    <Alert.Heading>{this.state.alert.title}</Alert.Heading>
                    <p>{this.state.alert.body}</p>
                </Alert>
            ):(
                <></>
            )}
            {this.state.error ? (
                <Alert style={{maxWidth:500,zIndex: 10000}} className={"mx-auto alert-top-right"}  variant="danger" onClose={()=>{this.setState({error: null})}} dismissible>
                    <Alert.Heading>{this.state.error.title}</Alert.Heading>
                    <p>{this.state.error.body}</p>
                </Alert>
            ):(
                <></>
            )}
            <UploadImagesModal
                campaignId={this.state.campaign._id}
                show={this.state.showUploadImgModal}
                handleImageChange={(message) => {
                    this.setState({
                        alert:{
                            title:"Images Updated!",
                            body:message,
                        }});
                }}
                onHide={()=>{
                    this.setState({showUploadImgModal:false})
                }}
            />
        </div>
    }
}

function ExportPopover(exportAuthorizationXlsx,exportProposalXlsx,exportPhotosheets,exportOverrideXLSX,campaign,exportLoading){
    return <Popover id={"share-popover"}>
        <Row className={"px-4 py-2"}>
            <Col>
                <div className={"boring-btn w-100"} onClick={function (){
                    exportProposalXlsx()
                    // let now = new Date();
                    // let table = new TableExport(t,{
                    //     filename: "TELOS-EXPORT-"+now.toDateString() + "T"+now.getHours()+":"+now.getMinutes()+":"+now.getSeconds(),
                    //     formats: ['xlsx'],
                    //     exportButtons: false,
                    // });
                    // let key = t.getAttribute('tableexport-key')
                    // /* convert export data to a file for download */
                    // let exportData = table.getExportData();
                    // let xlsxData = exportData[key].xlsx; // Replace with the kind of file you want from the exportData
                    // table.export2file(xlsxData.data, xlsxData.mimeType, xlsxData.filename, xlsxData.fileExtension, xlsxData.merges, xlsxData.RTL, xlsxData.sheetname)
                }}>Proposal Grid</div>
            </Col>
        </Row>
        <Row className={"px-4 py-2"}>
            <Col>
                <div className={"boring-btn w-100"} onClick={function (){
                    exportAuthorizationXlsx();
                    // let now = new Date();
                    // let table = new TableExport(t,{
                    //     filename: "TELOS-EXPORT-"+now.toDateString() + "T"+now.getHours()+":"+now.getMinutes()+":"+now.getSeconds(),
                    //     formats: ['xlsx'],
                    //     exportButtons: false,
                    // });
                    // let key = t.getAttribute('tableexport-key')
                    // /* convert export data to a file for download */
                    // let exportData = table.getExportData();
                    // let xlsxData = exportData[key].xlsx; // Replace with the kind of file you want from the exportData
                    // table.export2file(xlsxData.data, xlsxData.mimeType, xlsxData.filename, xlsxData.fileExtension, xlsxData.merges, xlsxData.RTL, xlsxData.sheetname)
                }}>Authorization Grid</div>
            </Col>
        </Row>
        {/*<Row className={"px-4 py-2"}>*/}
        {/*    <Col>*/}
        {/*        <div className={"boring-btn"}>PDF</div>*/}
        {/*    </Col>*/}
        {/*</Row>*/}
        <Row className={"px-4 py-2"}>
            <Col>
                <div className={"boring-btn"} onClick={() => {
                    Axios.post(process.env.REACT_APP_BACKEND_URL+"/campaign/duplicate-campaign",{
                        campaign: {...campaign, boards: GetSelectedBoards(campaign.boards)},
                        campaignId: campaign._id,
                    }).then((response) => {
                        if(response.data && response.data.campaign && response.data.campaign._id){
                            window.open("/campaign/"+response.data.campaign._id, '_blank').focus();
                        }
                    }).catch(error => {
                        console.log(error);
                        if(error && error.response){
                            this.setState({error:{title:"Unable to Duplicate Campaign!",body:error.response.data.message}});
                        }
                    });
                }}>New Campaign</div>
            </Col>
        </Row>
        <Row className={"px-4 py-2"}>
            <Col>
                <div className={"boring-btn w-100"} onClick={function (){
                    exportPhotosheets()
                }}>
                    Photosheets{' '}
                    {exportLoading && <Spinner animation="border" variant="secondary" size="sm"/>}
                </div>
            </Col>
        </Row>
        <Row className={"px-4 py-2"}>
            <Col>
                <div className={"boring-btn w-100"} onClick={function (){
                    exportOverrideXLSX()
                }}>Override</div>
            </Col>
        </Row>
    </Popover>
}

export const EditBoards = withRouter(EditBoardsBase);
